import { t } from 'i18next';
import { PlanUpgradePrompt } from '../../../components/plan-upgrade-prompt';
import { PARTNERS_I18N } from '../constants';

const PAGE = PARTNERS_I18N.page;

/**
 * Upsell CTA shown in place of the toggle for partners the store's plan doesn't cover.
 * The behaviour is the shared plan-upgrade prompt, attributed to the partner that prompted it.
 */
export function PartnerUpsell({ partnerName }: { partnerName: string }) {
  return (
    <PlanUpgradePrompt
      availabilityLabel={t(`${PAGE}.upsell.available_on`)}
      changePlanLabel={t(`${PAGE}.upsell.change_plan`)}
      trackingLabel={partnerName}
    />
  );
}
